module.exports = __webpack_public_path__ + "img/journal.1ba6b42f.png";